<script setup lang="ts">
import {type Preview} from '../types/previews.ts';
import EmptyPreview from './Previews/EmptyPreview.vue';
import LoadingPreview from './Previews/LoadingPreview.vue';
import ErrorPreview from './Previews/ErrorPreview.vue';
import FileDiffPreview from './Previews/FileDiffPreview.vue';
import ProjectPageDiffPreview from './Previews/ProjectPageDiffPreview.vue';

const preview = defineModel<Preview>('preview', {
  type: Object,
  required: true,
});

defineEmits(['warnings']);
</script>

<template>
  <EmptyPreview v-if="preview.ty === 'empty'" />
  <LoadingPreview
    v-if="preview.ty === 'loading'"
    :loading="preview"
  />
  <ErrorPreview
    v-if="preview.ty === 'error'"
    :err="preview"
  />

  <ProjectPageDiffPreview
    v-if="preview.ty === 'proj-page-diff'"
    :key="preview.file.nameHash"
    v-model="preview"
    @warnings="$emit('warnings', $event)"
  />
  <FileDiffPreview
    v-if="preview.ty === 'file-diff'"
    v-model="preview"
    @warnings="$emit('warnings', $event)"
  />
</template>
